import {KTSVG} from '../../../../../_metronic/helpers'
import {useListViewCamera} from '../core/ListViewProviderCamera'
import {CloseOutlined} from '@ant-design/icons'

const CameraEditModalHeader = () => {
  const {setItemIdForUpdateCamera} = useListViewCamera()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Thông tin Camera 1</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdateCamera('')}
        style={{cursor: 'pointer'}}
      >
        <CloseOutlined style={{fontSize: '16px'}} />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {CameraEditModalHeader}
